export default __webpack_public_path__ + "static/media/159.06a86cdf.png";